<template>
  <div>
    <div
      id="modal_showApp"
      class="modal fade"
    >
    <div
      class="modal-dialog modal-full"
      style="max-width:1000px"
    >
      <div class="modal-content">
        <div class="modal-header">
            <button
            type="button"
            class="close"
            @click="closeModal('modal_showApp')"
            style="background: transparent; border: none; font-size: 2rem; color: #000000FF; outline: none; cursor: pointer;"
            :aria-label="$t('common.close')"
            :title="$t('common.close')"
            >
            <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span>
            </button>
          <!-- check if you are in approved order page then show this purchase button -->
          <button
            v-if="detialData.status_id_fk === 4"
            type="button"
            class="close rtl-mr-115"
            @click.prevent="$emit('open-purchase-modal', detialData)"
            style="position: none; color: rgb(46, 125, 50);"
          >
          <i class="material-icons rtl-mr-8" style="vertical-align: middle;">add_shopping_cart</i>
          </button>
          <button
            v-if="detialData.status_id_fk === 4"
            type="button"
            class="close rtl-mr-75"
            @click.prevent="$emit('open-refund-modal', detialData)"
            style="position: none; color: rgb(198, 40, 40);"
          >
          <i class="material-icons rtl-mr-8" style="vertical-align: middle;">block</i>
          </button>
          <button
            v-if="detialData.status_id_fk === 4"
            type="button"
            class="close rtl-mr-40"
            @click.prevent="$emit('open-partial-refund-modal', detialData)"
            style="position: none; color: rgb(255, 87, 34);"
          >
          <i class="fa fa-registered rtl-mr-8" style="vertical-align: middle;"></i>
          </button>
          <h3 class="modal-title">{{ $t('orders.viewOrderDetailsTitle') }}</h3>
        </div>

        <div class="modal-body">
          <order-images
            v-if="detialData.order_id"
            :formData="detialData"
          />
          <!-- <div
            class="row"
            v-if="detialData.images && detialData.images.length > 0"
          >
            <div
              class="col-12 col-xs-4 col-sm-3 col-md-3 mb-4"
              v-for="(img,i) in detialData.images"
              :key="i"
              style="cursor: pointer"
              @click="showImage(img)"
            >
              <img
                :src="`${$_image_path()}${img.order_image}`"
                alt="Image"
                width="100%"
                height="150px"
                style="border-radius: 4px"
              >
            </div>
          </div> -->

          <!-- <div
            v-if="detialData.order_branch_name"
            class="col-sm-6"
          >
            <h5><strong>Order Branch: </strong>{{ detialData.order_branch_name }}</h5>
          </div>

          <div
            v-if="detialData.approve_branch_name"
            class="col-sm-6"
          >
            <h5><strong>Approve Branch: </strong>{{ detialData.approve_branch_name }}</h5>
          </div>

          <div
            v-if="detialData.deliver_branch_name"
            class="col-sm-6"
          >
            <h5><strong>Deliver Branch: </strong>{{ detialData.deliver_branch_name }}</h5>
          </div> -->

          <div class="col-sm-6">
            <h5><strong>{{ $t('columns.customer') }}: </strong>{{ detialData.full_name }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>{{ $t('columns.email') }}: </strong> {{ detialData.email }}</h5>
          </div>
          <div class="col-sm-12">
            <h5><strong>{{ $t('columns.customerNote') }}: </strong>{{ detialData.customer_note }}</h5>
          </div>

          <div class="col-sm-6">
            <h5><strong>{{ $t('columns.phoneNumber') }}: </strong> {{ detialData.phone_number }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>{{ $t('columns.orderId') }}: </strong> {{ detialData.theOrderID }}</h5>
          </div>
          <!--<div class="col-sm-6"> -->
          <!--<h5 v-if="detialData.c_o_d == '1'"> <strong>Cash on Deliver: </strong> Yes</h5> -->
          <!--<h5 v-else> <strong>Cash on Deliver: </strong> No</h5> -->
          <!--</div>-->

          <div class="col-sm-6">
            <h5>
              <strong>{{ $t('columns.productUrl') }}: </strong>
              <a
                :href="detialData.product_url"
                target="_blank"
              >{{
                  detialData.product_url ? detialData.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (detialData.product_url.length > 25 ? '...' : '') : detialData.product_url
                }}
              </a>
            </h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>{{ $t('columns.productName') }} : </strong> {{ detialData.product_name }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.brand"
          >
            <h5><strong>{{ $t('columns.brand') }}: </strong>{{ detialData.brand }}</h5>
          </div>
          <div
            v-if="detialData.process_note"
            class="col-sm-6"
          >
            <h5><strong>{{ $t('customer.processNote') }} : </strong> {{ detialData.process_note }}</h5>
          </div>
          <div
            v-if="detialData.customer_process_note"
            class="col-sm-6"
          >
            <h5><strong>{{ $t('orders.customerProcessNoteLabel') }} : </strong> {{ detialData.customer_process_note }}</h5>
          </div>
          <div
            v-if="detialData.customer_process_note_image"
            class="col-sm-6"
          >
            <img
              :src="`${$_image_path()}${detialData.customer_process_note_image}`"
              :alt="$t('columns.preview')"
              style="width: 70px; height: 70px; object-fit: cover; border: 1px solid #ccc; flex:none !important"
            />
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.size"
          >
            <h5><strong>{{ $t('columns.size') }}: </strong>{{ detialData.size }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.type"
          >
            <h5><strong>{{ $t('columns.type') }}: </strong>{{ detialData.type }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>{{ $t('columns.status') }} : </strong>{{ detialData.status }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.color"
          >
            <h5><strong>{{ $t('customer.color') }}: </strong>{{ detialData.color }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>{{ $t('columns.quantity') }}: </strong>{{ detialData.quantity }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.coupon"
          >
            <h5><strong>{{ $t('columns.coupon') }}: </strong>{{ detialData.coupon }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.coupon"
          >
            <h5><strong>{{ $t('customer.couponPercentage') }}: </strong>{{ detialData.coupon_percentage }}%</h5>
          </div>
          <div class="col-sm-6">
            <h5 v-if="detialData.delivery_type == 'office delivery'">
              <strong>{{ $t('customer.deliveryType') }}: </strong>
              <span
                class="fa fa-building"
                style="color: teal"
              ></span>
              {{ detialData.delivery_type }}
            </h5>
            <h5 v-else>
              <strong>{{ $t('customer.deliveryType') }}: </strong>
              <span
                class="glyphicon glyphicon-home "
                style="color:teal"
              ></span>
              {{ detialData.delivery_type }}
            </h5>
          </div>

          <!-- <div class="col-sm-6">
            <h5 style="color: #ff5252"><strong>Transportation Type: </strong>{{ detialData.transportation_type_obj ? detialData.transportation_type_obj.name : '' }}</h5>
          </div> -->

          <!-- <div class="col-sm-6">
            <div class="d-flex mt-3">
              <div>
                <i
                  v-if="detialData.is_repackage"
                  class="fa fa-check-square text-primary"
                  style="font-size: 18px;"
                />
                <i
                  v-else
                  class="fa fa-square-o"
                  style="font-size: 18px"
                />
                <span
                  class="ml-2"
                  style="font-size: 15px;"
                >Repackage</span>
              </div>

              <div>
                <i
                  v-if="detialData.is_hold"
                  class="fa fa-check-square text-primary"
                  style="font-size: 18px;"
                />
                <i
                  v-else
                  class="fa fa-square-o"
                  style="font-size: 18px"
                />
                <span
                  class="ml-2"
                  style="font-size: 15px;"
                >Hold</span>
              </div>
            </div>
          </div> -->

          <!-- <div class="col-sm-6">
            <h5><strong>Other service: </strong> {{ detialData.other_service }}</h5>
          </div> -->

          <div
            v-if="detialData.repackage_price"
            class="col-sm-6"
          >
            <h5><strong>{{ $t('customer.repackagePrice') }}: </strong>{{ getCurrencySymbol() }}{{ detialData.repackage_price }}</h5>
          </div>

          <div
            v-if="detialData.hold_price"
            class="col-sm-6"
          >
            <h5><strong>{{ $t('customer.holdPrice') }}: </strong>{{ getCurrencySymbol() }}{{ detialData.hold_price }}</h5>
          </div>

          <div
            v-if="detialData.other_service_price"
            class="col-sm-6"
          >
            <h5><strong>{{ $t('customer.otherServicePrice') }}: </strong>{{ getCurrencySymbol() }}{{ detialData.other_service_price }}</h5>
          </div>

          <div
            v-if="detialData.handling_fee"
            class="col-sm-6"
          >
            <h5><strong>{{ $t('invoice.handlingFeeLabel') }}: </strong>{{ getCurrencySymbol() }}{{ detialData.handling_fee }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.bank_name"
          >
            <h5><strong>{{ $t('columns.bankName') }}: </strong> {{ detialData.bank_name }}
              <span
                v-if="$_has_perm('edit_bank_transaction') && hasTransaction"
                style="font-size: 15px"
              >
                <a @click="openEditBank">{{ $t('common.editQuestion') }}</a>
              </span>
            </h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.cancel_reason"
          >
            <h5><strong>{{ $t('columns.cancelReason') }}: </strong> {{ detialData.cancel_reason }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.canceled_by"
          >
            <h5><strong>{{ $t('customer.canceledBy') }}: </strong> {{ detialData.canceled_by.full_name }} <span style="opacity: 0.7; font-size: 12px">#{{ detialData.canceled_by.user_id }}</span></h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.quantity_charge"
          >
            <h5><strong>{{ $t('customer.quantityCharge') }}: </strong>{{ getCurrencySymbol() }}{{ detialData.quantity_charge }}</h5>
          </div>
          <!-- Turkey: show TL price + dollar price -->
          <template v-if="detialData.country === 'Turkey'">
            <div
              class="col-sm-6"
              v-if="detialData.the_tl_price"
            >
              <h5><strong>{{ $t('orders.itemPriceCurrencyLabel', { code: 'TL' }) }}: </strong>{{ detialData.the_tl_price }} ₺</h5>
            </div>
            <div
              class="col-sm-6"
              v-if="detialData.item_price"
            >
              <h5><strong>{{ $t('customer.itemPrice') }}: </strong>${{ detialData.item_price }}</h5>
            </div>
          </template>
          <!-- UAE: the_aed_price is AED, item_price is dollar -->
          <template v-else-if="detialData.country === 'UAE'">
            <div
              class="col-sm-6"
              v-if="detialData.the_aed_price"
            >
              <h5><strong>{{ $t('orders.itemPriceCurrencyLabel', { code: 'AED' }) }}: </strong>{{ detialData.the_aed_price }} AED</h5>
            </div>
            <div
              class="col-sm-6"
              v-if="detialData.item_price"
            >
              <h5><strong>{{ $t('customer.itemPrice') }}: </strong>${{ detialData.item_price }}</h5>
            </div>
          </template>
          <!-- China: the_cny_price is CNY, item_price is dollar -->
          <template v-else-if="detialData.country === 'China'">
            <div
              class="col-sm-6"
              v-if="detialData.the_cny_price"
            >
              <h5><strong>{{ $t('orders.itemPriceCurrencyLabel', { code: 'CNY' }) }}: </strong>¥{{ detialData.the_cny_price }}</h5>
            </div>
            <div
              class="col-sm-6"
              v-if="detialData.item_price"
            >
              <h5><strong>{{ $t('customer.itemPrice') }}: </strong>${{ detialData.item_price }}</h5>
            </div>
          </template>
          <!-- UK: the_gbp_price is GBP, item_price is dollar -->
          <template v-else-if="detialData.country === 'United Kingdom'">
            <div
              class="col-sm-6"
              v-if="detialData.the_gbp_price"
            >
              <h5><strong>{{ $t('orders.itemPriceCurrencyLabel', { code: 'GBP' }) }}: </strong>£{{ detialData.the_gbp_price }}</h5>
            </div>
            <div
              class="col-sm-6"
              v-if="detialData.item_price"
            >
              <h5><strong>{{ $t('customer.itemPrice') }}: </strong>${{ detialData.item_price }}</h5>
            </div>
          </template>
          <!-- Germany: the_eur_price is EUR, item_price is dollar -->
          <template v-else-if="detialData.country === 'Germany'">
            <div
              class="col-sm-6"
              v-if="detialData.the_eur_price"
            >
              <h5><strong>{{ $t('orders.itemPriceCurrencyLabel', { code: 'EUR' }) }}: </strong>€{{ detialData.the_eur_price }}</h5>
            </div>
            <div
              class="col-sm-6"
              v-if="detialData.item_price"
            >
              <h5><strong>{{ $t('customer.itemPrice') }}: </strong>${{ detialData.item_price }}</h5>
            </div>
          </template>
          <!-- USA: show only dollar price -->
          <template v-else-if="detialData.country === 'United States'">
            <div
              class="col-sm-6"
              v-if="detialData.item_price"
            >
              <h5><strong>{{ $t('customer.itemPrice') }}: </strong>${{ detialData.item_price }}</h5>
            </div>
          </template>
          <!-- Other warehouses: existing behaviour -->
          <template v-else>
            <div
              class="col-sm-6"
              v-if="detialData.the_tl_price"
            >
              <h5><strong>{{ $t('orders.itemPriceCurrencyLabel', { code: 'TL' }) }}: </strong>
                <span v-if="detialData.currency === '$'">${{ detialData.the_tl_price }}</span>
                <span v-else>{{ detialData.the_tl_price }} {{ getCurrencySymbol() }}</span>
              </h5>
            </div>
            <div
              class="col-sm-6"
              v-if="detialData.item_price"
            >
              <h5><strong>{{ $t('customer.itemPrice') }}: </strong>${{ detialData.item_price }}</h5>
            </div>
          </template>
          <div
            class="col-sm-6"
            v-if="detialData.tax"
          >
            <h5><strong>{{ $t('columns.tax') }}: </strong>{{ getCurrencySymbol() }}{{ detialData.tax }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.national_tax"
          >
            <h5><strong>{{ $t('customer.internationalTax') }}: </strong>{{ getCurrencySymbol() }}{{ detialData.national_tax }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.item_weight"
          >
            <h5><strong>{{ $t('columns.weight') }}: </strong>{{ detialData.item_weight }} KG / {{ (detialData.item_weight / 0.4545).toFixed(2) }} LB</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.volume"
          >
            <h5><strong>{{ $t('columns.volume') }}: </strong>{{ detialData.volume }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.internal_shipping_handling"
          >
            <h5><strong>{{ $t('columns.intShipping') }}: </strong>${{ detialData.internal_shipping_handling }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.kreenex_fee"
          >
            <h5><strong>{{ $t('columns.shipzoneFee') }}: </strong>{{ getCurrencySymbol() }}{{ detialData.kreenex_fee }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.insurance"
          >
            <h5><strong>{{ $t('customer.insurance') }}: </strong>{{ getCurrencySymbol() }}{{ detialData.insurance }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.delivery_price"
          >
            <h5><strong>{{ $t('columns.deliveryPrice') }}: </strong>{{ getCurrencySymbol() }}{{ detialData.delivery_price }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.local_delivery"
          >
            <h5><strong>{{ $t('customer.delivery') }}: </strong>{{ Number(detialData.local_delivery) }} IQD</h5>
          </div>
          <!-- <div
            class="col-sm-6"
            v-if="detialData.price_weight"
          >
            <h5><strong>Processed At Price Weight: </strong>{{ getCurrencySymbol() }}{{ detialData.price_weight }}</h5>
          </div> -->
          <div
            class="col-sm-6"
            v-if="detialData.item_type"
          >
            <h5><strong>{{ $t('customer.itemType') }}: </strong>{{ detialData.item_type }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.discount"
          >
            <h5><strong>{{ $t('columns.discount') }}: </strong>{{ detialData.discount }}</h5>
          </div>
          <div
            class="col-sm-6"
          >

          </div>
          <div
            class="col-sm-6 red--text"
            v-if="detialData.status == 'refunded'"
          >
            <h5><strong>{{ $t('orders.refundAmountLabel') }}: </strong>${{ detialData.money_amount }}</h5>
          </div>

          <div class="col-sm-6">
            <h5>
              <strong>{{ $t('columns.warehouse') }}: </strong>
              <span v-if="flagCodeByCountry(detialData.country)">
                <flag :iso="flagCodeByCountry(detialData.country)" />
              </span>
              &nbsp; {{ detialData.country }}
            </h5>
          </div>

          <div
            v-if="detialData.track_number"
            class="col-sm-6"
          >
            <h5><strong>{{ $t('columns.trackNumber') }}: </strong> {{ detialData.track_number }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.barcode"
          >
            <h5><strong>{{ $t('columns.orderNumber') }}: </strong> {{ detialData.barcode }}</h5>
          </div>
          <div
            class="col-sm-6 col-md-6"
            v-if="detialData.qrcode"
          >
            <div class="col-xs-4 col-sm-4 col-md-3">
              <h5><strong>{{ $t('columns.qrCode') }}:</strong></h5>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-4">
              <qr-code
                :text="detialData.order_id.toString()"
                :size="size"
              ></qr-code>
            </div>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.description"
          >
            <h5><strong>{{ $t('columns.description') }} : </strong>{{ detialData.description }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.refund_reason"
          >
            <h5><strong>{{ $t('customer.refundReason') }}: </strong>{{ detialData.refund_reason }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.note"
          >
            <h5><strong>{{ $t('columns.note') }}: </strong>{{ detialData.note }}</h5>
          </div>

          <div class="col-sm-12" style="margin-top: 5px;">
            <div class="row">
              <div
                v-if="detialData.partial_refunds && detialData.partial_refunds.length"
                class="col-sm-6"
              >
                <h5><strong>{{ $t('orders.partialRefundsLabel') }}</strong></h5>
                <ol>
                  <li
                    v-for="pr in detialData.partial_refunds"
                    :key="pr.partial_refund_id"
                    style="font-size: 14px"
                    class="mb-1"
                  >
                    <div class="ml-2">
                      {{ $t('columns.amount') }}: {{ getCurrencySymbol() }}{{ pr.amount }}
                      <span class="ml-2 text--secondary">{{ $t('orders.partialRefundAtBy', { date: $options.filters.moment(pr.created_at, 'YYYY-MM-DD hh:mm a'), name: pr.user.full_name }) }}</span>
                    </div>
                    <div class="ml-2">{{ pr.note }}</div>
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div class="col-sm-12" style="margin:5px 0; background-color: #FAF8F8FF;border:1px solid #bbb; border-radius: 5px;">
            <div class="col-sm-6">
              <h5><strong>{{ $t('customer.orderDate') }}: </strong>{{ detialData.order_date }}</h5>
            </div>
            <div
            class="col-sm-6"
            v-if="detialData.confirm_date"
          >
            <h5><strong>{{ $t('columns.confirmDate') }}: </strong> {{ detialData.confirm_date }}</h5>
          </div>
          <div
            class="col-sm-4"
            v-if="detialData.warehouse_date"
          >
            <h5><strong>{{ $t('columns.warehouseDate') }}: </strong>{{ detialData.warehouse_date }}</h5>
          </div>
          <div
            class="col-sm-4"
            v-if="detialData.from_date"
          >
            <h5><strong>{{ $t('columns.fromDate') }}: </strong>{{ detialData.from_date }}</h5>
          </div>
          <div
            class="col-sm-4"
            v-if="detialData.to_date"
          >
            <h5><strong>{{ $t('columns.toDate') }}: </strong>{{ detialData.to_date }}</h5>
          </div>
          </div>

          <div class="col-sm-12" style="background-color: #f5d7a8;border:1px solid #bbb; border-radius: 5px;">
            <div class="col-sm-6 col-md-4">
              <h5><strong>{{ $t('columns.buyCost') }}: </strong>${{ detialData.buy_cost != null ? (Number(detialData.buy_cost) * Number(detialData.quantity || 1)).toFixed(2) : '—' }}</h5>
            </div>
            <div class="col-sm-6 col-md-4">
              <h5><strong>{{ $t('columns.purchaseCost') }}: </strong>${{ (Number(detialData.item_price || 0) * Number(detialData.quantity || 1) + Number(detialData.national_tax || 0) + Number(detialData.delivery_price || 0)).toFixed(2) }}</h5>
            </div>
            <!-- <div class="col-sm-4">
              <h5><strong>Actual cost: </strong>${{ detialData.actual_price }}</h5>
            </div> -->
            <div class="col-sm-6 col-md-4">
              <h5>
                <strong>{{ $t('columns.totalAmount') }}: </strong>${{ detialData.total_amount }}
                <span
                  v-if="detialData.payment_status"
                  :style="{ background: paymentStatusColor(detialData.payment_status).bg, color: paymentStatusColor(detialData.payment_status).color, padding: '2px 8px', borderRadius: '12px', fontSize: '12px', marginLeft: '6px' }"
                >{{ paymentStatusLabel(detialData.payment_status) }}</span>
              </h5>
            </div>

          </div>

        </div>

        <div class="modal-footer"></div>
      </div>
    </div>

    <!-- <v-dialog
      v-model="imageDialog"
      width="500"
    >
      <v-card>
        <img
          :src="`${$_image_path()}${theImg}`"
          alt=""
          width="100%"
        >
      </v-card>
    </v-dialog> -->
  </div>

  <edit-bank
    :editBank="editBank"
    :banks="banks"
    :currentBank="selectedBank"
  ></edit-bank>
  </div>
</template>

<script>
import editBank from './editBank.vue'
import axios from 'axios'

export default {
  components: {
    editBank
  },
  props: ['detialData', 'closeModal'],

  watch: {
    detialData: {
      handler(newVal) {
        console.log('detialData changed', newVal);
        if (newVal && newVal.order_id) {
          this.checkTransaction()
        }
      },
      immediate: true,
      deep: true
    }
  },

  data() {
    return {
      imageDialog: false,
      theImg: '',
      size: 50,
      warehouses: [],
      selectedBank: null,
      banks: [],
      transactionId: null,
      hasTransaction: false
    }
  },

  created() {
    this.getWarehouses()
  },

  methods: {
    showImage(img) {
      this.theImg = img.order_image
      this.imageDialog = true
    },
    getCurrencySymbol() {
      return this.detialData.currency || '$'
    },
    paymentStatusColor(status) {
      const map = {
        not_paid: { bg: '#F63049', color: '#FFFFFF' },
        partial_paid: { bg: '#FFC85C', color: '#6B4C00' },
        paid: { bg: '#89D7B7', color: '#1A5940' },
        cancel: { bg: '#FB8C00', color: '#FFFFFF' }
      }
      return map[status] || { bg: '#F5F5F5', color: '#616161' }
    },
    paymentStatusLabel(status) {
      const map = {
        not_paid: this.$t('invoice.unpaidStatus'),
        partial_paid: this.$t('invoice.partialPaidStatus'),
        paid: this.$t('invoice.paidStatus'),
        cancel: this.$t('invoice.cancelStatus')
      }
      return map[status] || (status ? status.replace(/_/g, ' ') : '')
    },
    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.warehouses = response.data.data.map(w => ({ country: w.country, flag_code: w.flag_code }))
        })
    },
    flagCodeByCountry(country) {
      const match = this.warehouses.find(w => w.country === country)
      return match ? match.flag_code : null
    },

    openEditBank() {
      if (this.banks.length === 0) {
        this.fetchBanks().then(() => {
          this.fetchTransactionId().then(() => {
            $('#editBankModal').modal('show');
          });
        });
      } else {
        this.fetchTransactionId().then(() => {
          $('#editBankModal').modal('show');
        });
      }
    },

    fetchBanks() {
      const token = localStorage.getItem('access_token')
      return axios.get('/api/get_banks', { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        console.log('Banks response:', res.data);
        this.banks = res.data.data;
      }).catch(err => {
        console.error('Error fetching banks:', err);
      });
    },

    fetchTransactionId() {
      const token = localStorage.getItem('access_token')
      return axios.get(`/api/orders/${this.detialData.order_id}/bank-transaction`, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        console.log('Transaction response:', res.data);
        this.transactionId = res.data.data.bank_transaction_id;
        this.selectedBank = res.data.data.bank_id_fk;
      }).catch(err => {
        console.error('No bank transaction found', err);
        this.transactionId = null;
      });
    },

    editBank(newBankId) {
      console.log('Editing bank to', newBankId);
      if (!this.transactionId) {
        console.error('No bank transaction found for this order');
        return;
      }
      const token = localStorage.getItem('access_token')
      axios.put(`/api/bank_transactions/${this.transactionId}/update-bank`, { bank_id: newBankId }, { headers: { Authorization: 'Bearer ' + token } }).then(() => {
        console.log('Bank updated successfully');
        const bank = this.banks.find(b => b.bank_id == newBankId);
        this.detialData.bank_name = bank.bank_name;
        this.$toast.success(this.$t('finance.bankUpdatedSuccessfully'));
      }).catch(err => {
        console.error('Failed to update bank', err);
      });
    },

    checkTransaction() {
      console.log('checkTransaction called for order', this.detialData.order_id);
      const token = localStorage.getItem('access_token')
      axios.get(`/api/orders/${this.detialData.order_id}/bank-transaction`, { headers: { Authorization: 'Bearer ' + token } }).then(() => {
        this.hasTransaction = true
      }).catch(() => {
        this.hasTransaction = false
      })
    }
  }
}
</script>

<style>
.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/viewOrderDetails.vue